import { EventListSkeleton } from '../events'

export default EventListSkeleton
